<div class="accounts-users-page-container">
  <div class="table-header">
    <p-iconfield iconPosition="left">
      <p-inputicon>
        <i class="pi pi-search"></i>
      </p-inputicon>
      <input type="text" pInputText placeholder="Search..." (input)="onSearch($event)" />
    </p-iconfield>
    <p-button
      label="Create Account User"
      icon="pi pi-plus"
      severity="primary"
      (onClick)="onCreateUserAccount()"
    ></p-button>
  </div>
  <app-accounts-table />
  <app-users-table />
</div>

<!-- Create Account/User dialog -->
<p-dialog [modal]="true" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false" [(visible)]="showDialog">
  <div class="dialog-content">
    <div class="form-field">
      <label for="externalId">External ID *</label>
      <input
        class="field-input"
        id="externalId"
        type="text"
        pInputText
        placeholder="Enter external user ID (e.g., from identity provider)"
        [formField]="userAccountForm.externalId"
      />
      @let externalIdField = userAccountForm.externalId();
      @if (externalIdField.touched() && !externalIdField.valid()) {
        <small class="p-error">
          @for (error of externalIdField.errors(); track error.kind) {
            {{ error.message }}
          }
        </small>
      }
    </div>

    <div class="form-field">
      <label for="email">Email *</label>
      <input
        class="field-input"
        id="email"
        type="email"
        pInputText
        placeholder="Enter user email"
        [formField]="userAccountForm.email"
      />
      @let emailField = userAccountForm.email();
      @if (emailField.touched() && !emailField.valid()) {
        <small class="p-error">
          @for (error of emailField.errors(); track error.kind) {
            {{ error.message }}
          }
        </small>
      }
    </div>

    <div class="form-field">
      <label for="name">Name</label>
      <input
        class="field-input"
        id="name"
        type="name"
        pInputText
        placeholder="Enter Name"
        [formField]="userAccountForm.name"
      />
    </div>

    <div class="form-field">
      <label for="accountName">Account Name*</label>
      <input
        class="field-input"
        id="accountName"
        type="accountName"
        pInputText
        placeholder="Enter Account Name"
        [formField]="userAccountForm.accountName"
      />
      @let accountNameField = userAccountForm.accountName();
      @if (accountNameField.touched() && !accountNameField.valid()) {
        <small class="p-error">
          @for (error of accountNameField.errors(); track error.kind) {
            {{ error.message }}
          }
        </small>
      }
    </div>

    <div class="form-field">
      <label for="accountDescription">Account Description</label>
      <textarea
        class="field-input"
        id="accountDescription"
        placeholder="Enter account description"
        rows="3"
        [formField]="userAccountForm.accountDescription"
      ></textarea>
    </div>

    <div class="form-field">
      <label for="groupName">Group Name *</label>
      <input
        class="field-input"
        id="groupName"
        type="groupName"
        pInputText
        placeholder="Enter Group Name"
        [formField]="userAccountForm.groupName"
      />
      @let groupNameField = userAccountForm.groupName();
      @if (groupNameField.touched() && !groupNameField.valid()) {
        <small class="p-error">
          @for (error of groupNameField.errors(); track error.kind) {
            {{ error.message }}
          }
        </small>
      }
    </div>

    <div class="form-field">
      <label for="groupDescription">Group Description</label>
      <textarea
        class="field-input"
        id="groupDescription"
        pTextarea
        placeholder="Enter group description"
        rows="3"
        [formField]="userAccountForm.groupDescription"
      ></textarea>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <p-button label="Cancel" severity="secondary" [disabled]="saving()" (onClick)="showDialog.set(false)"></p-button>
    <p-button
      label="Create"
      [loading]="saving()"
      [disabled]="!isFormValid()"
      (onClick)="onSaveUserAccount()"
    ></p-button>
  </ng-template>
</p-dialog>
